// extracted by mini-css-extract-plugin
module.exports = {"main-header":"simpleheader_main-header__0Dw6Y","container__logo":"simpleheader_container__logo__EyLGz"};